"use client";

import { useState, Fragment } from "react";
import Form from "next/form";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { updateRolesAction } from "../actions";
import DialogAlert from "./DialogAlert";
import SubmitButton from "./SubmitButton";
import { UserList } from "./UserList";
import { User } from "@/api/users";

export default function UpdateRolesButton({
  roles,
  users,
}: {
  roles: string[];
  users: User[];
}) {
  const [open, setOpen] = useState(false);
  const [alertVisible, setAlertVisible] = useState<boolean>(false);
  const [selectedRoles, setSelectedRoles] = useState<Record<string, boolean>>(
    {},
  );

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setSelectedRoles({});
  };

  const handleRoleToggle = (role: string) => {
    setSelectedRoles((prev) => ({
      ...prev,
      [role]: !prev[role],
    }));
  };

  const handleAction = async (formData: FormData) => {
    try {
      await updateRolesAction(formData);
      handleClose();
    } catch (error) {
      console.error("updateRolesAction", error);
      setAlertVisible(true);
    }
  };

  return (
    <>
      <Button variant="outlined" color="primary" onClick={handleOpen}>
        Update Roles
      </Button>
      <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
        <Form action={handleAction}>
          <DialogAlert
            message="There was a problem updating user roles"
            setVisible={setAlertVisible}
            visible={alertVisible}
          />
          <DialogTitle>Update User Roles</DialogTitle>
          <DialogContent>
            <p>This will effect the following users:</p>
            <UserList users={users} />
            {users.map((user) => (
              <input key={user.id} type="hidden" name="ids" value={user.id} />
            ))}
            {roles.map((role) => (
              <input key={role} type="hidden" name="all_roles" value={role} />
            ))}
            <div style={{ fontWeight: 500, marginBottom: "16px" }}>
              Select Roles
            </div>
            <FormGroup>
              {roles.map((role) => (
                <Fragment key={role}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedRoles[role] || false}
                        onChange={() => handleRoleToggle(role)}
                      />
                    }
                    label={role}
                  />
                  <input
                    type="hidden"
                    name={`role_${role}`}
                    value={selectedRoles[role] ? "true" : "false"}
                  />
                </Fragment>
              ))}
            </FormGroup>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary" type="button">
              Cancel
            </Button>
            <SubmitButton label="Update" pendingLabel="Updating..." />
          </DialogActions>
        </Form>
      </Dialog>
    </>
  );
}
